import Calendar from './calendar/sr_RS';
import DatePicker from './date-picker/sr_RS';
import Pagination from './pagination/sr_RS';
import TimePicker from './time-picker/sr_RS';

export default {
  locale: 'sr',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filter',
    filterConfirm: 'Primeni filter',
    filterReset: 'Resetuj filter',
    emptyText: 'Nema podataka',
    selectAll: 'ObeleÅ¾i sve na trenutnoj strani',
    selectInvert: 'Obrni selekciju na trenutnoj stranici',
  },
  Modal: {
    okText: 'U redu',
    cancelText: 'OtkaÅ¾i',
    justOkText: 'U redu',
  },
  Popconfirm: {
    okText: 'U redu',
    cancelText: 'OtkaÅ¾i',
  },
  Transfer: {
    notFoundContent: 'Nisu pronaÄeni rezultati pretrage',
    searchPlaceholder: 'PretraÅ¾ite ovde',
    itemUnit: 'stavka',
    itemsUnit: 'stavki',
  },
  Select: {
    notFoundContent: 'Nije pronaÄeno',
  },
  Upload: {
    uploading: 'Slanje...',
    removeFile: 'Ukloni fajl',
    uploadError: 'GreÅ¡ka prilikom slanja',
    previewFile: 'Pogledaj fajl',
  },
};
